import React from 'react';
import { useViewport } from '../../utils';
import colors from '../../utils/colors';

const Bar = ({value, total}) => {
  const { isMobile } = useViewport()
  const barWidth = isMobile ? '2px' : '5px'
  const widthInPercent = ((value/total)*100)

  return (
    <div className="relative" style={{maxWidth: '185px'}}>
      <hr
        className="absolute z-20 left-0 rounded-lg box-border"
        style={{
          top: '50%',
          transform: 'translateY(-50%)',
          borderColor: colors.green,
          borderWidth: barWidth,
          width: `${widthInPercent > 100 ? 100 : widthInPercent}%`
        }}
      />
      <hr
        className="absolute w-full z-10 left-0 rounded-lg box-border"
        style={{top: '50%', transform: 'translateY(-50%)', borderColor: '#eee'}}
      />
    </div>
  )
}

export default Bar
